(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["br-fireworks-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const gate = document.getElementById('br-fw-gate');
    if (!gate) return;

    const storageKey = 'br_fw_catalog_access_2026';
    const accessDuration = 12 * 60 * 60 * 1000;
    const expectedHash = 'f1d11bbe5a03f38f85657aa44a29aa6bad8c0db63e0ed70488c222af2be41f9b';
    const form = document.getElementById('br-fw-gate-form');
    const input = document.getElementById('br-fw-password');
    const error = document.getElementById('br-fw-gate-error');

    const unlock = () => {
      document.documentElement.classList.remove('br-fw-locked');
      gate.remove();
    };

    try {
      if (Number(localStorage.getItem(storageKey)) > Date.now()) {
        unlock();
        return;
      }
    } catch (storageError) {
      console.warn('Catalog access storage is unavailable.', storageError);
    }

    document.documentElement.classList.add('br-fw-locked');
    input.focus();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;

      const normalized = input.value.trim().toUpperCase();
      const bytes = new TextEncoder().encode(normalized);
      const digest = await crypto.subtle.digest('SHA-256', bytes);
      const actualHash = Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');

      if (actualHash === expectedHash) {
        try {
          localStorage.setItem(storageKey, String(Date.now() + accessDuration));
        } catch (storageError) {
          console.warn('Catalog access could not be stored.', storageError);
        }
        unlock();
        return;
      }

      input.value = '';
      input.focus();
      error.hidden = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
